import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

export const NavTrigger = ({ to, testId, label, active, hasDropdown, dropdownOpen }) => {
  const Tag = to ? Link : 'button';
  const isLit = active || dropdownOpen;
  return (
    <Tag
      {...(to ? { to } : {})}
      data-testid={testId}
      className={`relative flex items-center gap-1.5 px-4 py-2.5 text-[14px] font-medium rounded-lg transition-colors duration-200 ${
        isLit ? 'text-white' : 'text-[#CBD5E1] hover:text-white'
      }`}
    >
      {label}
      {hasDropdown && (
        <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`} />
      )}
      <span className={`absolute bottom-0 left-1/2 -translate-x-1/2 h-[2px] bg-[#F29B3D] rounded-full transition-all duration-200 ${
        isLit ? 'w-6 opacity-100' : 'w-0 opacity-0'
      }`} />
    </Tag>
  );
};

const ALIGN_CLASSES = {
  right: 'absolute top-full right-0',
  center: 'absolute top-full left-1/2 -translate-x-1/2',
  screen: 'fixed top-[68px] lg:top-[72px] left-1/2 -translate-x-1/2'
};

export const DropdownWrap = ({ open, align = 'center', onMouseEnter, onMouseLeave, children }) => (
  <div
    className={`${ALIGN_CLASSES[align] || ALIGN_CLASSES.center} pt-3 transition-all duration-200 ${
      open ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2 pointer-events-none'
    }`}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </div>
);
